module.exports = __webpack_public_path__ + "static/img/new-08.3a3e48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-08.png
// module id = BNnX
// module chunks = 0